import logo from '../logo.png';

let thingsToDo = ["Belajar GIT & CLI", "Belajar HTML & CSS", "Belajar Javascript", "Belajar ReactJS Dasar", "Belajar ReactJS Advance"]

const Body = () => {    
    return(
    <>
        <div className='custom-body'>
            <div style={{justifyContent: "center"}}>
                <img src={logo}  alt="logo" />
            </div>
            <h2 className='custom-h2'>THINGS TO DO</h2>
            <p>During bootcamp in sanbercode</p>
            <hr/>
            <input type="checkbox" /> 
            {thingsToDo[0]} 
            <hr/>
            <input type="checkbox" /> 
            {thingsToDo[1]} 
            <hr/>
            <input type="checkbox" /> 
            {thingsToDo[2]} 
            <hr/>
            <input type="checkbox" /> 
            {thingsToDo[3]} 
            <hr/>
            <input type="checkbox" /> 
            {thingsToDo[4]} 
            <hr/>
            <input type="submit" value="SEND" className='custom-button' /> 
        </div>
    </>
    )
}

export default Body
